export { getCoreOptions } from './coreOptions';
export * from './embeddedPlayerService';
export * from './SharedAbortController';
export * from './SharedTimeoutId';
export * from './themesService';
export * from './designSystemService';
export * from './featureFlagsService';
export * from './widgets';
export * from './download';
export * from './request/requestHelper';
export * from './request/dateHelper';
export * from './request/deviceHelper';
export * from './perf/uiaPerfCollector';

export * from './errors/CFAccessDeniedError';
export * from './errors/AccessDeniedError';

export * from './utils';

// Network API service (default provider). At app build time, rspack's
// NormalModuleReplacementPlugin swaps ./network/apiService for ./network/apiService.<provider>
// (consumer, telegram, …) according to NX_PUBLIC_PACKAGE_NETWORK. apiService imports its deps from
// specific relative files (not this barrel), so no cycle; kept last here purely for readability.
export { fetchJson, getBody } from './network/apiService';
